module.exports = __webpack_public_path__ + "static/media/contacts_banner.27b9a681.webp";